
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Page 分页</h1>
<p>当数据量比较大时，使用分页分解数据，实现快速响应。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>基础用法。页数过多会自动折叠。默认最多显示5页。超出5页时折叠。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;h4&gt;不同数据总量&lt;/h4&gt;
    &lt;Page :total=&quot;50&quot;/&gt;
    &lt;Page :total=&quot;100&quot;/&gt;

    &lt;h4&gt;设置当前页page&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; :page=&quot;page&quot; @change=&quot;pageChange&quot;/&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        data(){
            return {
                page: 5
            }
        },
        methods: {
            pageChange(page, pageSize){
                this.$Message.info(`当前页为${page}，当前每页条数为${pageSize}`)
            }
        }       
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="SZPX">
                <template slot="description"><p>设置<code>order</code>属性可以实现 总数据量<code>total</code>、分页<code>page</code>、每页条数<code>pageSize</code>、跳转<code>jump</code>之间的排序关系并展示对应的功能。</p>
<p>设置<code>totalText</code>和<code>pageSize</code>属性可以分别控制总数据量和每页条数选择项的显示方式。</p>
</template>
                <template slot="title">设置排序 <a href="#SZPX" data-title="设置排序">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<p></p>
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;h4&gt;只展示总数据量和分页&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; order=&quot;total, page&quot;/&gt;
    &lt;h4&gt;只展示每页条数和分页&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; order=&quot;page, pageSize&quot;/&gt;
    &lt;h4&gt;全部展示四项&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; order=&quot;total, page, pageSize, jump&quot;/&gt;
    &lt;h4&gt;全部展示四项--不同的排序&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; order=&quot;page, pageSize, jump, total&quot;/&gt;
    &lt;h4&gt;totalText和pageSize&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; order=&quot;total, page, pageSize, jump&quot; totalText=&quot;总共 {total} 条数据&quot; pageSizeText=&quot;每页 {pageSize} 条&quot; /&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="DYBKHBJYSDFY">
                <template slot="description"><p>设置<code>border</code>属性可以实现带有边框的分页样式。默认不展示边框。</p>
</template>
                <template slot="title">带有边框和背景颜色的分页 <a href="#DYBKHBJYSDFY" data-title="带有边框和背景颜色的分页">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;h4&gt;显示边框&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; border /&gt;
    &lt;h4&gt;显示背景&lt;/h4&gt;
    &lt;Page :total=&quot;100&quot; background /&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="MNLXDFY">
                <template slot="description"><p>设置属性<code>size=&quot;mini&quot;</code>可以实现迷你类型的分页。</p>
</template>
                <template slot="title">迷你类型的分页 <a href="#MNLXDFY" data-title="迷你类型的分页">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Page size=&quot;mini&quot; :total=&quot;100&quot; /&gt;
    &lt;Page size=&quot;mini&quot; :total=&quot;100&quot; background /&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="THSYYXYYTB">
                <template slot="description"><p>自定义实现上一页下一页图标。</p>
</template>
                <template slot="title">替换上一页下一页图标 <a href="#THSYYXYYTB" data-title="替换上一页下一页图标">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Page :total=&quot;100&quot; preText=&quot;上一页&quot; nextText=&quot;下一页&quot; /&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="page-props" class="anchor-title">Page props <a class="header-anchor" href="#page-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>page</td>
<td>Number</td>
<td>当前页</td>
<td>1</td>
</tr>
<tr>
<td>total</td>
<td>Number</td>
<td>数据总量</td>
<td>0</td>
</tr>
<tr>
<td>pageSize</td>
<td>Number</td>
<td>每页条数</td>
<td>10</td>
</tr>
<tr>
<td>pageSizeOption</td>
<td>Array</td>
<td>配置可选择的每页条数，建议不要超过4项</td>
<td>[10, 20, 30, 40]</td>
</tr>
<tr>
<td>maxPage</td>
<td>Number</td>
<td>最多显示分页数量，超出时折叠</td>
<td>5</td>
</tr>
<tr>
<td>size</td>
<td>String</td>
<td>分页尺寸，可选值 <code>mini</code></td>
<td>default</td>
</tr>
<tr>
<td>background</td>
<td>Boolean</td>
<td>是否显示背景色</td>
<td>-</td>
</tr>
<tr>
<td>border</td>
<td>Boolean</td>
<td>是否显示边框</td>
<td>-</td>
</tr>
<tr>
<td>hidenOnlySinglePage</td>
<td>Boolean</td>
<td>当只有一页或者数据量为0时是否显示分页，设置为true则不显示</td>
<td>-</td>
</tr>
<tr>
<td>preText</td>
<td>String</td>
<td>上一页文字，替换上一页的图标</td>
<td>-</td>
</tr>
<tr>
<td>nextText</td>
<td>String</td>
<td>下一页文字，替换下一页的图标</td>
<td>-</td>
</tr>
<tr>
<td>order</td>
<td>String</td>
<td>分页排序及显示对应功能，各值使用逗号隔开。例如：<code>total, page, pageSize, jump</code></td>
<td>-</td>
</tr>
<tr>
<td>totalText</td>
<td>String</td>
<td>设置总数据量的显示方式，其中<code>{total}</code>为占位符，替换总数据量</td>
<td>共 total 条</td>
</tr>
<tr>
<td>pageSizeText</td>
<td>String</td>
<td>设置每页条数选择项的显示方式，其中<code>{pageSize}</code>为占位符，替换总数据量</td>
<td>pageSize 条/页</td>
</tr>
</tbody>
</table>
<h3 id="page-event" class="anchor-title">Page event <a class="header-anchor" href="#page-event">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>返回值</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>当前页和每页条数变化时出发</td>
<td>page, pageSize</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h4',[_vm._v("不同数据总量")]),_vm._v(" "),_c('Page',{attrs:{"total":50}}),_vm._v(" "),_c('Page',{attrs:{"total":100}}),_vm._v(" "),_c('h4',[_vm._v("设置当前页page")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"page":_vm.page},on:{"change":_vm.pageChange}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data(){
            return {
                page: 5
            }
        },
        methods: {
            pageChange(page, pageSize){
                this.$Message.info(`当前页为${page}，当前每页条数为${pageSize}`)
            }
        }       
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h4',[_vm._v("只展示总数据量和分页")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"order":"total, page"}}),_vm._v(" "),_c('h4',[_vm._v("只展示每页条数和分页")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"order":"page, pageSize"}}),_vm._v(" "),_c('h4',[_vm._v("全部展示四项")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"order":"total, page, pageSize, jump"}}),_vm._v(" "),_c('h4',[_vm._v("全部展示四项--不同的排序")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"order":"page, pageSize, jump, total"}}),_vm._v(" "),_c('h4',[_vm._v("totalText和pageSize")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"order":"total, page, pageSize, jump","totalText":"总共 {total} 条数据","pageSizeText":"每页 {pageSize} 条"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('h4',[_vm._v("显示边框")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"border":""}}),_vm._v(" "),_c('h4',[_vm._v("显示背景")]),_vm._v(" "),_c('Page',{attrs:{"total":100,"background":""}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Page',{attrs:{"size":"mini","total":100}}),_vm._v(" "),_c('Page',{attrs:{"size":"mini","total":100,"background":""}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Page',{attrs:{"total":100,"preText":"上一页","nextText":"下一页"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  